import { isNewRelicEnabled, NEW_RELIC_PLATFORM_SURFACE } from './newRelicConfig';
import { getObservabilityRoutePatterns } from './routePatterns';
import { syncNewRelicRouteContext } from './syncNewRelicRouteContext';

const routePatterns = getObservabilityRoutePatterns();

/**
 * Subscribe to React Router navigations so route context is set during soft navigations,
 * before child route effects run — not after the matched screen has rendered.
 * Initial sync still runs post-mount from RoutesComponent useEffect; initial load relies on
 * setCurrentRouteName, persisted route attributes, and routeView PageAction, not interaction().setName().
 */
type RoutableRouter = {
  state: { location: { pathname: string } };
  subscribe: (listener: (state: { location: { pathname: string } }) => void) => () => void;
};

export function attachNewRelicRouteSync(router: RoutableRouter): () => void {
  if (!isNewRelicEnabled()) return () => {};

  let lastSyncedPathname: string | undefined;

  const sync = (pathname: string) => {
    if (pathname === lastSyncedPathname) return;

    const nr = window.newrelic;
    if (!nr) return;

    syncNewRelicRouteContext(nr, pathname, routePatterns, NEW_RELIC_PLATFORM_SURFACE);
    lastSyncedPathname = pathname;
  };

  sync(router.state.location.pathname);
  return router.subscribe(state => sync(state.location.pathname));
}
